import { AppCheckboxWithLabel, AppCheckboxWithLabelProps } from 'components/core/AppCheckbox/AppCheckboxWithLabel';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import { useField } from 'formik';

interface Props {
  name: string;
}

export const FormikAppCheckboxWithLabel = ({
  name,
  ...rest
}: Props & Omit<AppCheckboxWithLabelProps, 'checked' | 'onChange'>) => {
  const [field, , helpers] = useField(name);

  const onChange = () => {
    helpers.setValue(!field.value);
  };

  return (
    <>
      <AppCheckboxWithLabel
        {...rest}
        checked={field.value}
        onChange={onChange}
        checkboxProps={{
          onBlur: field.onBlur,
        }}
      />
      <AlluraFormikErrorMessage fieldName={name} />
    </>
  );
};
